export const PRODUCT_CATEGORIES = 'ProductCategory'
export const ORDERS = 'Orders'
export const ABANDONED_ORDERS = 'AbandonedOrders'
export const DISCOUNTS = 'Discounts'
export const GLOBAL_VARIANTS = 'GlobalVariant'
export const DIGITAL_DOWNLOADS = 'DigitalDownloads'
export const INTERGATED_SHIPPING = 'IntegratedShipping'
export const ECOMDASH = 'EcomDash'
export const ECOMDASH_REGISTERED = 'EcomdashRegistered'
